// extracted by mini-css-extract-plugin
export default {"container":"f_US","commonData":"Mpx_","admins":"k5vd","specialists":"hFML","actions":"tw0J"};